module.exports = __webpack_public_path__ + "img/edge_divers_velo_electrique.ef0611c2.svg";